/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { uGrid as t, classNames as l } from "@progress/kendo-react-common";
import * as a from "react";
const c = (e) => {
  const r = e.unstyled, s = r && r.uGrid ? r.uGrid : t;
  return /* @__PURE__ */ a.createElement("td", { className: l(s.hierarchyTd({})), role: "gridcell" });
};
export {
  c as GridDetailHierarchyCell
};
